<template>
	<table
		:class="[
			'table-list',
		]"
		border="0"
		cellpadding="0"
		cellspacing="0"
	>
		<thead>
			<tr v-if="inputSearch || filterColumns || deleteSeat || includeFilter || addButton || editCont">
				<th :colspan="totalVisibleColumns" :class="[`text-xs-${direction}`, 'movil-header-row']">
					<button
						class="vertical-align-middle btn-clean-filter no-movil"
						v-if="clearFilter"
						type="button"
						@click="tableClearFilter">
						Limpiar Filtro
					</button>
					<button
						class="vertical-align-middle no-movil"
						v-if="includeFilter"
						type="button"
						@click="tableOption">
						<v-icon dark>filter_list</v-icon>
					</button>
					<v-menu
						offset-y
						:nudge-left="97"
						max-height="300"
						content-class="columns-menu"
						fixed
						v-model="showMenu"
						v-if="filterColumns"
						:close-on-content-click="false">
						<button slot="activator">
							<v-icon>view_column</v-icon>
						</button>
						<div>
							<template v-for="column in columns">
								<v-checkbox
									v-model="column.checked"
									:label="column.name"
									:key="column.id"
									hide-details
									v-if="!column.flagVisible"
									color="success"
									style="background: white">
								</v-checkbox>
							</template>
							<div class="apply text-xs-center">
								<button @click="toggleColumns">Aplicar</button>
							</div>
						</div>
					</v-menu>
					<v-btn
						target="_blank"
						:disabled="disabledEditAccou"
						v-if="editCont"
						color="blue"
						class="btn-edit"
						@click="$emit('edit-accouting')"
					>
						Editar
					</v-btn>
					<v-tooltip top>
						<v-btn
							slot="activator"
							color="red"
							v-if="deleteSeat"
							class="btn-auto pa-0 ma-2 btn-delete"
							type="button"
							@click="openDeleteSeat"
							>
							<v-icon color="white" size="19">
								delete
							</v-icon>
						</v-btn>
						<span>{{ tooltipDelete }}</span>
					</v-tooltip>
					<v-tooltip top>
						<v-btn
							slot="activator"
							@click="addAIconAction"
							color="blue"
							v-if="addIcon"
							class="btn-auto pa-0 ma-0 btn-add no-movil"
							type="button">
							<v-icon color="white" size="19">add</v-icon>
						</v-btn>
						<span>{{ nameTooltip }}</span>
					</v-tooltip>
					<slot name="text"></slot>
					<button
						v-if="addButton"
						type="button"
						@click="addOption">
						<v-icon>add</v-icon>
					</button>
					<div class="search-input" v-if="inputSearch">
						<input
							type="text"
							v-model="search"
							@keyup.enter="searchRows"
							@keyup.esc="searchRows"
						>
						<v-icon>search</v-icon>
					</div>
				</th>
			</tr>
			<tr class="movil-table">
				<th
					v-if="selectable"
					:class="{ 'hide-selectable-on-movil': hideSelectableOnMovil }"
				>
					<input
						type="checkbox"
						:value="checkAll"
						:checked="checkAll"
						class="input-checkbox"
						@change="selectedAll($event)">
				</th>
				<th
					is="table-column-item"
					v-for="column in columns"
					:key="column.id"
				  	:column="column"
					v-show="column.visible"
					:class="[
						'text-xs-center',
						{ 'column-movil-version': !column.movil },
					]"
				>
				</th>
			</tr>
		</thead>
		<tbody v-for="(row) in rows" :key="row[keyValue]">
				<tr v-if="code === 'major-general'">
					<td colspan="3" style="font-weight: bold">Codigo de cuenta: {{row.accountingCode}}</td>
					<td colspan="4" style="font-weight: bold; text-align: left">Descripción de la cuenta: {{row.description}}</td>
				</tr>
				<tr v-if="code === 'accounting-book'">
					<td colspan="2" style="font-weight: bold">Fecha: {{row.date | exactDate}}</td>
					<td colspan="2" style="font-weight: bold;">Asiento: {{row.code}}</td>
					<td colspan="2" style="font-weight: bold; text-align: left">Descripción: {{row.gloss}}</td>
				</tr>
				<tr v-for="(ro, inde) in row.details"
					:key="ro[keyValue]"
					:class="[
						{ 'row-checked' : row.isSelected || row.isVisited },
						'movil-table',
					]"
					@click="rowIsSelected(row)"
				>
					<td
						v-if="selectable"
						class="check-row"
						:class="{ 'hide-selectable-on-movil': hideSelectableOnMovil }"
					>
						<input
							type="checkbox"
							v-model="ro.isSelected"
							class="input-checkbox"
							:disabled="dispatchDetail && (row.flagDispatch > 0)">
					</td>
					<slot name="rows" :index="inde" :row="ro"></slot>
				</tr>
		</tbody>
		<tfoot class="table-pagination">
			<tr v-if="mainList && rows.length > 0">
				<td :colspan="totalVisibleColumns" class="text-xs-right">
					<input
						type="text"
						@input="selectPage($event.target.value)"
						:value="currentPage"
						class="search-input unique-input">
					<a
						v-for="(page, index) in pages"
						:key="index"
						:class="{ 'active-page': page === currentPage }"
						@click="selectPage(page)">{{page}}</a>
					<span>|</span>
					<a @click="selectLastPage">>></a>
				</td>
			</tr>
			<tr v-if="rows.length === 0">
				<td v-if="showAccounting"
				:colspan="totalVisibleColumns"
				:style="!mainList ?
						'border-bottom-left-radius: 0px; border-bottom-right-radius: 0px;' :
						'border-bottom-left-radius: 10px; border-bottom-right-radius: 10px;'">
					<p style="text-align:center; margin: 150px 0 150px 0;color: #a9bac2;font-weight: 600;">
						Selecciona un registro y contabiliza para que aparezcan los asientos
					</p>
				</td>
				<td class="td-record" :colspan="totalVisibleColumns" v-else-if="showRecord">
					<p class="show-record">
						Seleccione un modulo para visualizar información
					</p>
				</td>
				<td v-else :colspan="totalVisibleColumns"
					:style="!mainList ?
						'border-bottom-left-radius: 0px; border-bottom-right-radius: 0px;' :
						'border-bottom-left-radius: 10px; border-bottom-right-radius: 10px;'">
					<p style="text-align:center; margin: 5px 0 0 5px">
						No hay información que mostrar
					</p>
				</td>
			</tr>
		</tfoot>
	</table>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';
import TableColumnItem from './table-column-item';
import helper from './../../../shared/helper';

const ADD_REQUEST_EVENT = 'on-add-event';
const LOCAL_SEARCH_EVENT = 'on-local-search';
const SEARCH_EVENT = 'on-search-event';
const ON_DRAG_EVENT = 'on-drag-event';
const ON_DRAG_ENTER = 'on-drag-enter';
const ON_DRAG_LEAVE = 'on-drag-leave';
const ON_DROP_EVENT = 'on-drop-event';
const ON_PAGE_EVENT = 'on-page';
const ROW_IS_SELECTED = 'row-is-selected';
const ROW_ON_CLICK = 'row-on-click';
const SELECTED_ALL_EVENT = 'on-selected-all';
const TABLE_OPTION_EVENT = 'table-option-event';
const TABLE_CLEAR_FILTER = 'clear-filter';
const components = {
	TableColumnItem,
	appTooltipButton,
};
function addOption() {
	this.$emit(ADD_REQUEST_EVENT);
}
function addAIconAction() {
	this.$emit('add-icon');
}
function pagination(pageNumber, totalRecords) {
	const current = pageNumber;
	const last = totalRecords;
	const delta = 2;
	const left = current - delta;
	const right = current + delta + 1;
	const range = [];
	const rangeWithDots = [];
	let l = null;
	for (let i = 1; i <= last; i += 1) {
		/* eslint-disable no-mixed-operators */
		if (i === 1 || i === last || i >= left && i < right) {
			range.push(i);
		}
	}
	/* eslint-disable no-restricted-syntax */
	for (const i of range) {
		if (l) {
			if (i - l === 2) {
				rangeWithDots.push(l + 1);
			} else if (i - l !== 1) {
				rangeWithDots.push('...');
			}
		}
		rangeWithDots.push(i);
		l = i;
	}
	return rangeWithDots;
}
function data() {
	return {
		direction: 'right',
		search: '',
		showMenu: false,
		showman: false,
	};
}
function mounted() {
	window.addEventListener('resize', this.optionsDirection);
	this.optionsDirection();
	const columnsInLocalStorage = helper.getLocalData(`${this.$attrs.name}::columns`);
	if (columnsInLocalStorage) {
		this.columns.forEach((col) => {
			const newCol = col;
			const colToChange = columnsInLocalStorage.find(c => c.id === newCol.id);
			if (colToChange) {
				newCol.visible = colToChange.visible;
				newCol.checked = colToChange.checked;
			}
		});
	}
	if (this.localStorage) {
		const searchFromLocalStorage = helper.getLocalData(`${this.$attrs.name}::search`);
		if (searchFromLocalStorage) {
			this.search = searchFromLocalStorage;
			this.$emit(SEARCH_EVENT, searchFromLocalStorage);
		}
	}
}
function toggleColumns() {
	this.selectedColumns = this.columns.filter(c => !c.checked);
	this.columns.forEach((col) => {
		const newCol = col;
		const colToChange = this.selectedColumns.find(c => c.id === newCol.id);
		newCol.visible = typeof colToChange === 'undefined';
	});
	helper.setLocalData(`${this.$attrs.name}::columns`, this.selectedColumns);
	this.showMenu = false;
}
function selectedAll({ target }) {
	this.$emit(SELECTED_ALL_EVENT, target.checked);
}
function rowIsSelected(row) {
	if (this.selectable) {
		this.$set(row, 'isSelected', !row.isSelected);
		this.$emit(ROW_IS_SELECTED, row);
	} else {
		this.$emit(ROW_ON_CLICK, row);
	}
}
function searchRows($event) {
	const keyCode = $event.keyCode;
	if (keyCode === 27) {
		this.search = '';
	}
	if (this.localSearch) {
		const dataToLocalSearch = this.search.toLowerCase();
		helper.setLocalData(`${this.$attrs.name}::search`, dataToLocalSearch);
		this.$emit(LOCAL_SEARCH_EVENT, dataToLocalSearch);
	} else {
		helper.setLocalData(`${this.$attrs.name}::search`, this.search);
		this.$emit(SEARCH_EVENT, this.search);
	}
}
function onDragEnter(row) {
	this.$emit(ON_DRAG_ENTER, row);
}
function onDragLeave(row) {
	this.$emit(ON_DRAG_LEAVE, row);
}
function onDrop(row) {
	this.$emit(ON_DROP_EVENT, row);
}
function onDrag(row) {
	this.$emit(ON_DRAG_EVENT, row);
}
function changePage(page) {
	if (page !== '...') {
		if (page !== this.currentPage) {
			this.$emit(ON_PAGE_EVENT, page);
		}
	}
}
function cleanSearch(val) {
	if (val) {
		this.search = '';
	}
}
function selectPage(page) {
	let newPage = page > this.lastPage ? this.lastPage : page;
	newPage = newPage <= 0 ? 1 : newPage;
	changePage.call(this, Number(newPage));
}
function selectLastPage() {
	changePage.call(this, this.lastPage);
}
function tableOption() {
	const action = {
		active: true,
		code: 'filter-by',
		color: '#fafafa',
		imgSrc: '/static/img/actions-list/cancel.svg',
		open: true,
		title: 'FILTRAR POR',
		width: 229,
	};
	this.$emit(TABLE_OPTION_EVENT, action);
}
function createAction() {
	this.$emit('create-action');
}
function openDeleteSeat() {
	const action = {
		active: true,
		code: 'delete-seat',
		color: '#fafafa',
		imgSrc: 'https://japi-static.s3.amazonaws.com/japi-sales-error/behind.png',
		open: true,
		title: 'Eliminar Asiento',
		width: 300,
	};
	this.$emit('delete-seat', action);
}
function optionsDirection() {
	if (window.innerWidth < 768) {
		this.direction = 'center';
	} else {
		this.direction = 'right';
	}
}
function totalVisibleColumns() {
	return this.columns.filter(c => c.visible).length + 1;
}
function pages() {
	return pagination(this.currentPage, this.lastPage);
}
function tableClearFilter() {
	this.$emit(TABLE_CLEAR_FILTER);
}
export default {
	name: 'table-mayor',
	components,
	computed: {
		pages,
		totalVisibleColumns,
	},
	data,
	methods: {
		addOption,
		addAIconAction,
		createAction,
		openDeleteSeat,
		onDrag,
		onDragEnter,
		onDragLeave,
		onDrop,
		optionsDirection,
		rowIsSelected,
		searchRows,
		selectedAll,
		selectPage,
		selectLastPage,
		tableOption,
		toggleColumns,
		tableClearFilter,
	},
	mounted,
	props: {
		addButton: {
			default: false,
			type: Boolean,
		},
		checkAll: {
			type: Boolean,
			default: false,
		},
		columns: {
			type: Array,
			required: true,
		},
		action: {
			default: false,
			type: Boolean,
		},
		currentPage: {
			type: Number,
			default: 1,
		},
		dispatchDetail: {
			default: false,
			type: Boolean,
		},
		filterColumns: {
			default: true,
			type: Boolean,
		},
		hideSelectableOnMovil: {
			default: false,
			type: Boolean,
		},
		includeFilter: {
			type: Boolean,
			default: false,
		},
		inputSearch: {
			default: true,
			type: Boolean,
		},
		localSearch: {
			type: Boolean,
			default: false,
		},
		localStorage: {
			type: Boolean,
			default: false,
		},
		rows: {
			type: Array,
			required: true,
		},
		selectable: {
			type: Boolean,
			default: false,
		},
		lastPage: {
			type: Number,
			default: 0,
		},
		keyValue: {
			type: String,
			default: 'id',
		},
		mainList: {
			type: Boolean,
			default: true,
		},
		cleanSearch: {
			default: false,
			type: Boolean,
		},
		detailSeat: {
			default: false,
			type: Boolean,
		},
		deleteSeat: {
			default: false,
			type: Boolean,
		},
		editCont: {
			default: false,
			type: Boolean,
		},
		showNewSeat: {
			default: false,
			type: Boolean,
		},
		showDetailSeat: {
			default: false,
			type: Boolean,
		},
		nameTooltip: {
			type: String,
			default: '',
		},
		addIcon: {
			type: Boolean,
			default: false,
		},
		tooltipDelete: {
			type: String,
			default: '',
		},
		clearFilter: {
			default: false,
			type: Boolean,
		},
		showAccounting: {
			type: Boolean,
			default: false,
		},
		showTableAccounting: {
			type: Boolean,
			default: false,
		},
		rowsDetails: {
			type: Array,
			default: () => [],
		},
		showRecord: {
			type: Boolean,
			default: false,
		},
		disabledEditAccou: {
			type: Boolean,
			default: true,
		},
		createdAdd: {
			type: Boolean,
			default: true,
		},
		code: {
			default: '',
			type: String,
		},
	},
	watch: {
		cleanSearch,
	},
};
</script>

<style lang="scss" scoped>
	input {
		background-color: transparent;
		border-style: none;
	}
	table.table-list {
		width: 100%;
		font-family: "AvenirRegular" !important;
		border-radius: 10px;
		border: PowderBlue 5px solid;
		thead {
			background-color: #02979b !important;
			color: #fff;
			font-size: 12px;
			th {
				align-items: center;
				font-family: map-get($fonts, opens-semibold);
				font-size: 11px;
				font-weight: 500;
				height: 30.5px;
				padding: 8px 5px 0;
				position: relative;
				text-align: center;
				@media (max-width: 768px) {
					height: 35px;
					overflow: auto;
					padding: 10px 5px 0;
					white-space: nowrap;
				}
				&:first-child {
					padding-left: 9px;
					text-align: left;
				}
				.check-list {
					margin-top: -1px !important;
				}
			}
			tr:first-child {
				th {
					&:last-child {
						padding-right: 5px;
					}
				}
			}
			button {
				align-items: center;
				background-color: color(green-icon);
				border: 0px;
				border-radius: 50%;
				display: inline-flex;
				height: 25px;
				justify-content: center;
				line-height: 22px;
				margin-left: 3px;
				outline: none;
				width: 25px;
				.v-icon {
					font-size: 16px !important;
				}
				.icon {
					color: white;
					height: 20px;
					line-height: 19px;
				}
			}
			.btn-clean-filter {
				background-color: map-get($colors, text-red-light);
				border-radius: 10px;
				color: map-get($colors, white);
				font-weight: 700;
				padding: 0 7px;
				width: auto
			}
		}
		&.is-not-selectable {
			th {
				&:first-child {
					width: auto;
				}
			}
		}
		tbody {
			tr {
				color: map-get($colors, tableText);
				font-family: map-get($fonts, opens-semibold);
				font-size: 11px;
				&:nth-child(odd) {
					background: #f4f6f8 !important;
					@media (max-width: 768px) {
						background: white;
					}
					&.row-checked {
						background-color: #33cfc71a !important;
					}
				}
				&:nth-child(even) {
					background-color: white;
				}
				td {
					align-items: center;
					border-right: 1px solid color(grey-divider);
					height: 30px;
					position: relative;
					text-align: center;

					@media (max-width: 768px) {
						border-right: none !important;
					}
					@media (max-width: 768px) {
						border-right: none;
						height: 43px;
						padding: 11px 0;
					}
					&:first-child:not(.is-not-selectable) {
						border-left: 1px solid transparent;
						border-right: 0px;
						padding-left: 8px;
						text-align: left;
						width: 34px;
					}
					&:last-child {
						border-right: 1px solid transparent;
					}
					.check-list {
						margin-top: -1px !important;
					}
					.table-icon {
						img {
							vertical-align: middle;
						}
						&.btn {
							background-color: transparent;
							box-shadow: none;
							margin: 0px;
							min-width: auto;
						}
					}
				}
				&:hover {
					background-color: color(btn-green-transparent);
					td:not(.td-employee) {
						border-bottom: 1px solid color(btn-green);
						border-top: 1px solid color(btn-green);
						color: color(black);
						font-family: map-get($fonts, opens-bold);
						height: 38px !important;
						&:first-child {
							border-left: 1px solid color(btn-green) !important;
						}
						&:last-child {
							border-right: 1px solid color(btn-green) !important;
						}
					}
				}
			}
			tr.is-select {
				td:not(.td-employee) {
					border-bottom: 1px solid map-get($colors, primary);
					border-top: 1px solid map-get($colors, primary);
					color: grey;
					font-family: map-get($fonts, opens-regular);
					&:first-child {
						border-left: 1px solid map-get($colors, primary);
					}
					&:last-child {
						border-right: 1px solid map-get($colors, primary);
					}
				}
				&-employee {
					td.td-employee {
						border-bottom: 1px solid map-get($colors, primary);
						border-top: 1px solid map-get($colors, primary);
						color: grey;
						font-family: map-get($fonts, opens-regular);
						&:first-child {
							border-left: 1px solid map-get($colors, primary);
						}
						&:last-child {
							border-right: 1px solid map-get($colors, primary);
						}
					}
				}
			}
		}
		tfoot {
			tr {
				td {
					background-color: white;
					border-bottom-left-radius: 10px;
					border-bottom-right-radius: 10px;
					border-top: 1px solid map-get($colors, subheaderText);
					box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, .2);
					height: 29px;
					padding-right: 17px;
					a {
						color: map-get($colors, paginationText);
						font-family: map-get($fonts, open-regular);
						font-size: 15px;
						font-weight: lighter;
						line-height: 10px;
						margin-left: 7px;
						padding: 5px;
						& + span {
							color: map-get($colors, grey-border);
							& + a {
								margin-left: 0px;
							}
						}
						&.active-page {
							color: red;
						}
						&:hover {
							font-size: 18px;
						}
					}
				}
			}
		}
		&.no-main-list {
			border-bottom: 1px solid map-get($colors, grey-border);
		}
		.search-input {
			border: 1px solid color(grey-icon) !important;
			background-color: color(grey);
			border-radius: 15px !important;
			display: inline-flex;
			height: 23px;
			max-width: 170px;
			vertical-align: middle;
			width: 100%;
			input {
				color: color(black);
				outline: none;
				padding: 0 10px;
				width: calc(100% - 25px);
			}
			.v-icon {
				align-self: center;
				color: color(grey-icon) !important;
				font-size: 20px;
				transform: rotate(90deg);
			}
			@media (max-width: 768px) {
				display: none;
				&.unique-input {
					width: 50px;
				}
			}
		}
		.checkbox {
			.icon {
				font-size: 14px;
			}
			.input-group--selection-controls__ripple {
				height: 15px;
				left: 13px;
				width: 15px;
			}
		}
		.input-checkbox {
			border: 1px solid map-get($colors, grey-border);
			border-radius: 1px;
			height: 15px;
			width: 15px;
		}
	}
	.unique-input {
		border: 1px solid map-get($colors, black);
		opacity: 0.1;
		padding-left: 5px;
		width: 50px;
	}
	.unique-input:focus-within{
		opacity: 1;
	}
	.row-checked {
		background-color: color(btn-green-transparent) !important;
	}
	.v-menu .v-icon {
		color: map-get($colors, white) !important;
	}
	.vertical-align-middle {
		vertical-align: middle;
	}
	.column-movil-version {
		@media (max-width: 768px) {
			display: none;
		}
	}
tr.movil-table {

	@media (max-width: 768px) {
		align-items: center;
		display: grid;
		font-size: size(small11) !important;
		grid-template-columns: repeat(auto-fit, minmax(20px, 1fr));
		.hide-selectable-on-movil {
			display: none;
		}
		td {
			overflow: hidden;
		}
	}
}
th.movil-header-row {
	@media (max-width: 768px) {
		display: none;
	}
}
.check-row {
	@media (max-width: 768px) {
		display: flex;
		grid-column: 1 / 2;
		grid-row: 1;
		justify-content: flex-start;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: auto !important;
	}
}
.btn-add {
	left: 6px;
	position: absolute;
	@media (max-width: 768px) {
		top: 2px;
	}
}
.btn-delete {
	left: 27px;
	position: absolute;
	top: 0;
}
.btn-add-mobile {
	display: none;
	@media (max-width: 768px) {
		background-color: map-get($colors, secondary) !important;
		border-radius: 2px !important;
		box-shadow: none !important;
		color: map-get($colors, white);
		display: block;
		height: 35px !important;
		font-size: 25px;
		margin-left: auto !important;
		padding: 0 !important;
		text-transform: none !important;
		width: 41px !important;
	}
}
.absolute-btn {
	display: none;
	@media (max-width: 768px) {
		display: block;
		padding: 0 !important;
	}
}
.background-table {
	background-color: #33cfc7;
	opacity: 0.12;
}
.background-blue-table {
	background-color: #006edb;
	opacity: 0.12;
}
.show-record {
	border: 1.5px dashed #006edb;
	color: #006edb;
	font-family: map-get($fonts, AvenirRegular);
	font-size: 14px;
	text-align: center;
	margin: 0 auto;
	max-width: 400px;
	padding: 20px 28px;
}
.td-record {
	background-color: rgba(255, 255, 255, 0.72);
	padding: 111px 0 130px 0;
}
.btn-edit {
	border-radius: 24px !important;
	top: 3px;
	color: white !important;
	font-family: map-get($fonts, AvenirDemi);
	font-size: 10px;
	position: absolute;
	left: 15px;
	width: 49px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/table/table-mayor.vue